'use strict';

var React = require('react');

var SvgPaymentFilledIcon = function SvgPaymentFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 10.227v-2.227c-.778 0-1.044.005-1.283.062a2.25 2.25 0 0 0-.65.27c-.21.128-.398.31-.943.854l-.594.594a.75.75 0 0 1-1.06-1.06l.654-.655c.46-.46.78-.78 1.16-1.012a3.75 3.75 0 0 1 1.083-.45c.433-.103.888-.103 1.546-.103h.087v1.48h11v1.62c0 .84 0 1.26-.163 1.581a1.5 1.5 0 0 1-.656.655c-.32.164-.74.164-1.581.164h-2.705a1.92 1.92 0 0 1-.61.73l-2.73 1.965c-.566.407-.93.67-1.336.859-.358.167-.736.29-1.125.363-.44.083-.889.083-1.586.083h-1.508a.75.75 0 0 1 0-1.5h1.436c.794 0 1.095-.003 1.379-.057.266-.05.524-.134.77-.248.261-.122.508-.296 1.152-.76l2.67-1.923a.423.423 0 0 0-.35-.753l-4.875 1.219a.75.75 0 0 1-.364-1.456l1.182-.295Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.587 5.069c.152.298.162.683.163 1.411h-11c0-.728.011-1.113.163-1.411a1.5 1.5 0 0 1 .656-.656c.32-.163.74-.163 1.581-.163h6.2c.84 0 1.26 0 1.581.163a1.5 1.5 0 0 1 .655.656Z"
  }));
};
SvgPaymentFilledIcon.displayName = "PaymentFilledIcon";

exports.SvgPaymentFilledIcon = SvgPaymentFilledIcon;
